import { attachLibraryImage, attachSocialImage, createSocialPost, generateSocialImage } from "./api";

export const emptyImage = () => ({ mode: "none", lib: null, mine: null, ai: null, prompt: "", style: "photo", aspect: "portrait", overlay: false, addLogo: true, service: "auto" });

// Saves a post with whichever picture was chosen: the branded poster, the person's own image, an AI picture, or none.
// The post is saved first, so a picture that fails never loses the text; `notes` says what could not be attached.
export async function savePostWithImage({ text, title, category, aiLabel, image, headline, sub, tag }) {
  const notes = [];
  const usingAi = image.mode === "ai" && image.ai;
  const poster = image.mode === "poster" && headline?.trim();
  let post = await createSocialPost({ text, title: title || text.slice(0, 60), category, ai_generated: aiLabel || !!usingAi,
    visual: poster ? { layout: "statement", tag, headline, sub } : undefined });
  const alt = headline || title || text.slice(0, 80);
  try {
    if (poster) post = await generateSocialImage(post.id);
    else if (image.mode === "mine" && image.mine) post = await attachSocialImage(post.id, image.mine.filename, image.mine.b64, alt, image.addLogo);
    else if (image.mode === "library" && image.lib) post = await attachLibraryImage(post.id, { image_id: image.lib.id });
    else if (usingAi) post = await attachSocialImage(post.id, "ai-picture.png", image.ai.b64, alt, false);  // the logo was added when it was made
  } catch { notes.push("The post is saved, but its picture could not be attached. Open the post to add one."); }
  return { post, notes };
}
